import { getAuthenticated } from './http';

export const fetchDashboardSummary = () => getAuthenticated('/api/dashboard/summary');
